
import SwitchControl from '@/components/switch-control.vue'
// import { Dialog, EventBus, EventBusEvents } from '@/event/EventBus'
import { Action, Getter } from 'vuex-class'
import { Device } from '@/store/types'
import audioPlayer from '@/utils/sounds'
import { Options, Vue } from 'vue-class-component'
import { useI18n } from 'vue-i18n'
import { EventBuss } from '@/utils/constants'

@Options({
    components: {
        SwitchControl
    }
})
class SettingDialogView extends Vue {
    iN = useI18n().t

    @Getter('device') device!: Device
    @Getter('userId') uid!: string
    @Getter('soundEffect') soundEffect!: number

    @Action('logOut') logOut!: (uname: string) => Promise<void>
    @Action('setSound') setSound!: (num: number) => void
    @Action('showLoading') showLoading!: () => void
    @Action('hideLoading') hideLoading!: () => void

    emitter!: Vue['emitter']
    $emit!: Vue['emit']

    // @Action('destroySession') destroySession!: () => void

    ClickLogOut(): void {
        // EventBus.$emit(EventBusEvents.SHOW_LOADER, true)
        this.$emit('on-close')
        this.emitter.emit(EventBuss.LOG_OUT)
    }

    OnClickChangePassword(): void {
        this.$emit('on-show-change-password-form')
    }

    OnCLickHistory(): void {
        this.$emit('on-show-history')
        this.$emit('on-close')
    }

    OnChangeSoundConfig(num: number): void {
        if (audioPlayer) audioPlayer.isOn = num
        this.setSound(num)
    }
    onClickOutside(): void {
        // EventBus.$emit(EventBusEvents.SHOW_DIALOGS, Dialog.SETTING)
    }

    OnClickCustumerService(): void {
        window.open(process.env.VUE_APP_CUSTUMER_SERVICE, '_blank')
    }

    OnClickRules(): void {
        // window.open(
        //     'http://kkw6888.com/resource/rules/rule_home.html',
        //     '_blank'
        // )
        this.$emit('on-show-rule')
        this.$emit('on-close')
    }
}
export default SettingDialogView
